module.exports = __webpack_public_path__ + "static/media/css2.65788bc6.svg";